/* Copyright (c) 2025 Xperi. All Rights Reserved. */

export const TOAST_MESSAGE_CLEAR = 'TOAST_MESSAGE_CLEAR';
export const TOAST_MESSAGE_HIDE = 'TOAST_MESSAGE_HIDE';
export const TOAST_MESSAGE_SHOW = 'TOAST_MESSAGE_SHOW';
